@if (product(); as product) {
    <div
        class="ca-product-tile ca-text-md"
        [class.is-different-product-type]="isDifferentProductType()"
        [class.is-selected]="isSelected()"
        (click)="selectProduct.emit(product)"
    >
        <div class="ca-product-tile-media">
            <img alt="{{ product.productName }}" [src]="product.pictureUrl || placeholderImageSrc" />
        </div>

        <div class="ca-product-tile-body">
            <div class="flex flex-col md:flex-row items-center gap-2">
                <div class="font-semibold">{{ product.productName }}</div>
                <!-- TODO: Uncomment when API ready -->
                <!-- <ca-tag type="green" [outline]="true" [rounded]="true">
                {{ 'CA.LABEL.RECOMMENDATION' | translate }}
            </ca-tag> -->
            </div>

            <div class="ca-product-tile-meta">
                <ca-product-meta-tile [label]="'CA.PRODUCT_TILE.ARTICLE_NR' | translate">{{ product.id }}</ca-product-meta-tile>
                @for (spec of product | caProductTechnicalData | slice: 0 : 1; track spec.name) {
                    <ca-product-meta-tile [label]="spec.name | translate">
                        {{ spec.value ?? '-' }}
                        @if (spec.unit) {
                            <span>
                                {{ spec.unit | translate }}
                            </span>
                        }
                    </ca-product-meta-tile>
                }
                <ca-product-meta-tile [label]="'CA.PRODUCT_TILE.TYPE' | translate">
                    {{ 'CA.DEVICE_TYPE.' + product.productType | translate }}
                </ca-product-meta-tile>
                <ca-product-meta-tile [label]="'CA.PRODUCT_TILE.PRICE' | translate">
                    {{ product.price | caCurrency: countryCode() : languageCode() }}
                </ca-product-meta-tile>
            </div>
        </div>

        <div class="ca-product-tile-action">
            <button
                mat-stroked-button
                class="ca-button ca-button-s"
                [disabled]="isDifferentProductType()"
                (click)="selectProduct.emit(product); $event.stopPropagation()"
            >
                @if (isSelected()) {
                    <mat-icon>check</mat-icon>
                }
                <span>{{ (isSelected() ? 'CA.BUTTON.SELECTED' : 'CA.BUTTON.SELECT') | translate }}</span>
            </button>
        </div>
    </div>
}
